
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/real-estate-agents-training",
      function () {
        return require("private-next-pages/real-estate-agents-training.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/real-estate-agents-training"])
      });
    }
  